import React, { useState } from 'react'
import { Card, List, Space, Typography, Tag, Select, Input, Button, message } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

const { Text } = Typography
const { Option } = Select
const { TextArea } = Input

const NotesContent = ({ accountData }) => {
  const [notes, setNotes] = useState([
    {
      id: 1,
      date: '2024-01-20',
      note: 'Patient requested payment plan. Discussed options and will follow up next week.',
      user: 'Chantelle Bosch',
      type: 'general'
    },
    {
      id: 2,
      date: '2024-01-15',
      note: 'Medical aid claim submitted for recent consultation. Awaiting response.',
      user: 'Admin',
      type: 'medical_aid'
    },
    {
      id: 3,
      date: '2024-01-10',
      note: 'Patient disputed charge for lab tests. Investigating with billing department.',
      user: 'Reception',
      type: 'dispute'
    }
  ])
  const [newNote, setNewNote] = useState('')
  const [noteType, setNoteType] = useState('general')

  const handleAddNote = () => {
    if (newNote.trim()) {
      setNotes([
        {
          id: notes.length + 1,
          date: dayjs().format('YYYY-MM-DD'),
          note: newNote,
          user: 'Current User',
          type: noteType
        },
        ...notes
      ])
      setNewNote('')
      message.success('Note added successfully')
    }
  }

  const getNoteTypeTag = (type) => {
    const typeMap = {
      general: { text: 'General', color: 'default' },
      medical_aid: { text: 'Medical Aid', color: 'blue' },
      payment: { text: 'Payment', color: 'green' },
      dispute: { text: 'Dispute', color: 'red' },
      follow_up: { text: 'Follow-up', color: 'orange' }
    }
    return typeMap[type] || typeMap.general
  }

  return (
    <div>
      <Card size='small' title='Add New Note' style={{ marginBottom: 16 }}>
        <Space direction='vertical' style={{ width: '100%' }}>
          <Select value={noteType} onChange={setNoteType} style={{ width: 200 }}>
            <Option value='general'>General Note</Option>
            <Option value='medical_aid'>Medical Aid Related</Option>
            <Option value='payment'>Payment Related</Option>
            <Option value='dispute'>Dispute/Query</Option>
            <Option value='follow_up'>Follow-up Required</Option>
          </Select>
          <TextArea
            rows={3}
            value={newNote}
            onChange={(e) => setNewNote(e.target.value)}
            placeholder='Enter your note here...'
          />
          <Button type='primary' icon={<PlusOutlined />} onClick={handleAddNote}>
            Add Note
          </Button>
        </Space>
      </Card>

      <Card size='small' title='Notes History'>
        <List
          dataSource={notes}
          renderItem={(note) => {
            const typeTag = getNoteTypeTag(note.type)
            return (
              <List.Item>
                <List.Item.Meta
                  title={
                    <Space>
                      <Text>{dayjs(note.date).format('DD MMM YYYY')}</Text>
                      <Tag color={typeTag.color}>{typeTag.text}</Tag>
                      <Text type='secondary'>- {note.user}</Text>
                    </Space>
                  }
                  description={note.note}
                />
              </List.Item>
            )
          }}
        />
      </Card>
    </div>
  )
}

export default NotesContent
